import { render, staticRenderFns } from "./productSet.vue?vue&type=template&id=0957d0c6&"
import script from "./productSet.vue?vue&type=script&lang=js&"
export * from "./productSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports